<template>
  <div class="workspace-documents">
    <!-- 工具栏 -->
    <div class="toolbar">
      <div class="toolbar-left">
        <el-select v-model="docType" size="small" style="width: 120px;" @change="handleSearch" clearable>
          <el-option label="全部文档类型" :value="null"></el-option>
          <el-option label="文件文档" :value="1"></el-option>
          <el-option label="图文文档" :value="3"></el-option>
        </el-select>
        
        <el-input 
          v-model="keyword" 
          placeholder="搜索关键字" 
          size="small"
          style="width: 200px;"
          clearable
          @keyup.enter="handleSearch"
          @clear="handleSearch">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        
        <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
      </div>
    </div>
    
    <!-- 表格 -->
    <el-table
      :data="docList"
      v-loading="loading"
      stripe
      style="width: 100%">
      <el-table-column prop="title" label="标题" min-width="200" >
        <template slot-scope="scope" >
          <span style="display:block;width: 100%;text-align: center;">{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="docType" label="文档类型" width="120">
        <template slot-scope="scope">
          <span  style="display:block; width: 100%; text-align: center; ">
            <el-tag size="small">
              {{ getTypeText(scope.row.docType) }}
            </el-tag>
          </span>
        </template>
      </el-table-column>
      
      <el-table-column prop="lastUpdatedAt" label="最后修改时间" width="200">

          <template slot-scope="scope">
            <span  style="display:block; width: 100%; text-align: center;">
               {{ formatDate(scope.row.lastUpdatedAt) }}
            </span>               
          </template>

      </el-table-column>
      
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <span  style="display:block; width: 100%; text-align: center;">        
            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="handleRemove(scope.row)">
              移除
            </el-button>
          </span>  
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      v-if="total > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
      style="margin-top: 16px; text-align: right;">
    </el-pagination>
    
    <!-- 文档详情对话框 -->
    <el-dialog title="文档详情" :visible.sync="detailVisible" width="600px" append-to-body>
      <el-form :model="currentDoc" label-width="100px">
        <el-form-item label="文档名称">
          <span>{{ currentDoc.title }}</span>
        </el-form-item>
        <el-form-item label="文档类型">
          <span v-if="currentDoc.docType == 1">文件</span>
          <span v-else-if="currentDoc.docType == 2">在线网页</span>
          <span v-else-if="currentDoc.docType == 3">图文文档</span>
          <span v-else-if="currentDoc.docType == 4">问答对文档</span>
        </el-form-item>
        <el-form-item label="唯一标识">
          <span>{{ currentDoc.docId || currentDoc.location }}</span>
        </el-form-item>

        <el-form-item label="最后修改时间">
          <span>{{ formatDate(currentDoc.lastUpdatedAt) }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getKbWorkspaceDocuments, remove_document_from_workspace } from '@/api/aics/kbWorkspace';
import {formatToBeijingTime }         from '@/util/date'

export default {
  name: 'WorkspaceDocuments',
  props: {
    workspaceSlug: {
      type: String,
      default: ''
    },
    workspaceName: {
      type: String,
      default: ''
    },
    tenantId: {
      type: [String, Number],
      required: true
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      docList: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      docType: null,
      keyword: '',
      detailVisible: false,
      currentDoc: {}
    }
  },
  watch: {
    workspaceSlug: {
      handler(newVal) {
        if (newVal) {
          this.loadData();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 供父组件调用的刷新方法
    async refresh() {
      return this.loadData();
    },
    
    async loadData() {
      if (!this.workspaceSlug) {
        console.log('等待选择知识库...');
        return;
      }
      
      this.loading = true;
      try {  
             console.info("getKbWorkspaceDocuments ",this.workspaceSlug)
        const res = await getKbWorkspaceDocuments(this.workspaceSlug);
        console.info("getKbWorkspaceDocuments res",res)
        if (res.code === 200) {
          let data = res.data || [];
          
          // 关键字过滤
          if (this.keyword) {
            data = data.filter(item => 
              item.title && item.title.toLowerCase().includes(this.keyword.toLowerCase())
            );
          }
          
          // 文档类型过滤
          if (this.docType) {
            data = data.filter(item => item.docType === this.docType);
          }
          
          // 前端分页
          this.total = data.length;
          const start = (this.pageNum - 1) * this.pageSize;
          const end = start + this.pageSize;
          this.docList = data.slice(start, end);
        } else {
          this.$message.error(res.message || '加载失败');
        }
      } catch (error) {
        console.error('加载工作区文档失败:', error);
        this.$message.error('加载工作区文档失败');
      } finally {
        this.loading = false;
      }
    },
    
    handleSearch() {
      this.pageNum = 1;
      this.loadData();
    },
    
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    
    handleDetail(row) {
      this.currentDoc = row;
      this.detailVisible = true;
    },
    
    async handleRemove(row) {
      try {
        await this.$confirm(`确定要从知识库【${this.workspaceName}】中移除该文档吗？`, '提示', { type: 'warning' });
        const res = await remove_document_from_workspace(this.tenantId, row.docpath, this.workspaceSlug);
        
        if (res.code === 200) {
          this.$message.success('移除成功');
          this.loadData();
        } else {
          this.$message.error(res.message || '移除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('移除文档失败:', error);
          this.$message.error('移除失败');
        }
      }
    },
    
    getTypeText(type) {
      const map = { 1: '文件文档', 3: '图文文档', 4: '问答对文档' };
      return map[type] || '未知'+type;
    },
    
    getStatusText(status) {
      const map = {
        0: '不在文档库',
        1: '待处理',
        2: '处理中',
        3: '已训练',
        4: '已移除'
      };
      return map[status] || '未知';
    },    
    formatDate(dateArr) {
      if (!dateArr) return '-';
      return formatToBeijingTime(dateArr);
      
      
    }
  }
}
</script>

<style scoped>
.workspace-documents {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.toolbar-left {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}
</style>